import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: false,
  proxy: 'https://api.aravia.com.co',
  // Services names
  accountingService: 'accounting',
  configurationService: 'configuration',
  treasuryService: 'treasury',
  thirdService: 'third',
  inventoryService: 'inventory',
  // TODO add documentStorageService: 'document-storage',
  authenticationService: 'authentication',
  salesService: 'sales',
  accountingFiscalManagerService: 'accounting-fiscal-manager',
  authWebService: 'auth-web',
  servicesWebService: 'services',

  // Frontends
  salesFrontend: '',
  inventoryFrontend: '',
  authFrontend: 'https://auth.aravia.com.co',
  helisaWebFrontend: 'https://web.aravia.com.co',
  servicesFrontend: '',
  accountingFrontend: 'https://accounting.aravia.com.co/',
  fiscalInformationFrontend: 'https://fiscal-information.aravia.com.co/',
  configurationFrontend: 'https://configuration.aravia.com.co/',
  treasuryFrontend: 'https://treasury.aravia.com.co/',
  accountingDocumentFrontend: 'https://document.aravia.com.co',

  // Others
  mongoPath: '/mongo',

  // Version
  version: '1.0.0',
  dateVersion: 'Enero 9 de 2024',

  // TODO delete
  documentStorage:
    'https://araviastrprodd4abb885.blob.core.windows.net/helisaweb',
};
